export function getPostHogConfig() {
  const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com';

  let isEU = false;
  try {
    const url = new URL(posthogHost);
    isEU = url.host.toLowerCase() === 'eu.i.posthog.com';
  } catch {
    // Default to US on invalid URL
  }

  return {
    isEU,
    apiHost: isEU ? 'https://eu.i.posthog.com' : 'https://us.i.posthog.com',
    assetsHost: isEU ? 'https://eu-assets.i.posthog.com' : 'https://us-assets.i.posthog.com',
    uiHost: isEU ? 'https://eu.posthog.com' : 'https://us.posthog.com',
  };
}
